import type { IconSvgObject } from './types';

const FlameIcon: IconSvgObject = [
  ["path", { d: "M12 21.5C16.1421 21.5 19.5 18.1421 19.5 14C19.5 12.5 19.5 11 18 8C17.6667 8.83333 16.6 11 15 11C15 5 12.3333 3.16667 11 2.5C10 7 4.5 8 4.5 14C4.5 18.1421 7.85786 21.5 12 21.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default FlameIcon;
